module.exports = __webpack_public_path__ + "static/img/b2.81898889.png";